import React from 'react';
import { usePdp } from '@context/PdpContext';
import useFormattedPrice from '@hooks/useFormattedPrice';
import KlarnaPlacement from '@components/product/ProductBuyZone/Klarna/KlarnaPlacement';

type ProxyKlarnaPlacementProps = {
  locale: string | undefined;
  placement: string;
  className: string;
};

export default function KlarnaProductPlacement({
  locale,
  placement,
  className,
}: ProxyKlarnaPlacementProps) {
  const { price } = usePdp();
  const { priceString } = useFormattedPrice(price);

  return (
    <KlarnaPlacement
      className={className}
      placement={placement}
      locale={locale}
      purchaseAmount={priceString}
    />
  );
}
